import { GenericIdbaErrorsModel } from './generic-idba-errors-model';

export class GenericIdbaResponseModel {
    data: any;
    errors: GenericIdbaErrorsModel[];
    success: boolean;
    status:number;
    message: string;

    constructor(response: any){
        this.data = response?.data;
        this.errors = response?.errors || response?.error?.errors;
        this.success = response?.success || false;
        this.status = response?.status || response?.error?.status;
        this.message = response?.message || "";
    }
}
